module.exports = __webpack_public_path__ + "static/media/mimenu-white.39d84918.svg";